module.exports = __webpack_public_path__ + "static/media/company-directory.facf0b32.svg";